import { EventQBus } from '../types/global';
import { ContentTracking } from './ContentTracking';

export class Tracking {
    private readonly eventQBus: EventQBus;
    public visibilityTracked = false;
    private variationId: number | 'missing' = 'missing';

    //accessible for testing
    contentTracking: ContentTracking | null = null;

    constructor(eventQBus?: EventQBus | null) {
        this.eventQBus = eventQBus || o_global.eventQBus;
    }

    public init(): void {
        this.registerVisibilityTrackingListener();

        this.eventQBus.on('ft5.richContent.variationChanged', ({ variationId, isInitialVariationChange }) => {
            const richContentElement = document.querySelector<HTMLElement>('.js_rc_component');
            if (richContentElement) {
                this.contentTracking = new ContentTracking(this.eventQBus, richContentElement, variationId || 'missing');
                if (isInitialVariationChange) {
                    this.contentTracking.trackPageImpression();
                }
            } else {
                this.contentTracking = null;
            }
        });
    }

    private registerVisibilityTrackingListener(): void {
        const relevantEvents = ['scroll', 'resize'];
        relevantEvents.forEach(type => {
            addEventListener(type, () => this.contentTracking?.trackRichContentVisibleIfRequired(), false);
        });
    }

    public trackRichContentVisible(): void {
        const variationId = this.variationId;
        this.eventQBus.emit('tracking.bct.submitEvent', {
            product_DetailInformation: 'richcontent',
            product_DetailInformationActivity: 'visible',
            product_RichContentProvider: Tracking.getProviderListOld(),
            product_VariationId: variationId || 'missing'
        });
    }

    private static getProviderListOld(): string {
        const dataContainer = document.querySelector<HTMLElement>('.js_rc_component');
        const providerList = dataContainer?.getAttribute('data-provider-list-a2b');
        return providerList || 'missing';
    }
}